import { MoveEventsBerthCall } from '../types/ViewModel/MoveEventsBerthCall';
import { MoveEventsCargoOperation } from '../types/ViewModel/MoveEventsCargoOperation';
import { MoveEventsCargoOperationFactory } from './MoveEventsCargoOperationFactory';

export class MoveEventsBerthCallFactory {
    private moveEventsCargoOperationFactory = new MoveEventsCargoOperationFactory();
    constructor() {}

    public createMoveEventsBerthCallItem(
        fromBerthCallId: number,
        toBerthCallId: number,
        moveEventsCargoOperationList: MoveEventsCargoOperation[]
    ): MoveEventsBerthCall {
        const cargoOpList = moveEventsCargoOperationList.map((item) => {
            return this.moveEventsCargoOperationFactory.createMoveEventsCargoOperationItem(item.fromCargoOperationId, item.toCargoOperationId);
        });
        return new MoveEventsBerthCall(fromBerthCallId, toBerthCallId, cargoOpList);
    }

    public createMoveEventsBerthCallBM(moveEventsBerthCall: MoveEventsBerthCall): any {
        const cargoOpBMList = moveEventsBerthCall.moveEventsCargoOperationList.map((item) => {
            return this.moveEventsCargoOperationFactory.createMoveEventsCargoOperationBM(item);
        });
        return {
            fromBerthCallId: moveEventsBerthCall.fromBerthCallId,
            toBerthCallId: moveEventsBerthCall.toBerthCallId,
            moveEventsCargoOperationList: cargoOpBMList,
        };
    }
}
